module.exports = __webpack_public_path__ + "img/cross.5420f207.svg";